import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';

import { Totes_ds_container_statusesService } from './Totes.datasource.index';
import { Totes_ds_container_typesService } from './Totes.datasource.index';
import { Totes_ds_container_types_ddService } from './Totes.datasource.index';
import { Totes_ds_get_first_available_tote_for_inductionService } from './Totes.datasource.index';
import { Totes_ds_get_tote_containersService } from './Totes.datasource.index';
import { Totes_ds_tote_container_statuses_ddService } from './Totes.datasource.index';
import { Totes_ds_validate_scanned_toteService } from './Totes.datasource.index';
import { Totes_ds_warehouses_ddService } from './Totes.datasource.index';

@Injectable({ providedIn: 'root' })
export class Totes_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
  public Totes: Totes_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_container_statuses: Totes_ds_container_statusesService;
  public get ds_container_statuses(): Totes_ds_container_statusesService {
    if(!this._ds_container_statuses) {
      this._ds_container_statuses = this.injector.get(Totes_ds_container_statusesService);
    }
    return this._ds_container_statuses;
  }
  private _ds_container_types: Totes_ds_container_typesService;
  public get ds_container_types(): Totes_ds_container_typesService {
    if(!this._ds_container_types) {
      this._ds_container_types = this.injector.get(Totes_ds_container_typesService);
    }
    return this._ds_container_types;
  }
  private _ds_container_types_dd: Totes_ds_container_types_ddService;
  public get ds_container_types_dd(): Totes_ds_container_types_ddService {
    if(!this._ds_container_types_dd) {
      this._ds_container_types_dd = this.injector.get(Totes_ds_container_types_ddService);
    }
    return this._ds_container_types_dd;
  }
  private _ds_get_first_available_tote_for_induction: Totes_ds_get_first_available_tote_for_inductionService;
  public get ds_get_first_available_tote_for_induction(): Totes_ds_get_first_available_tote_for_inductionService {
    if(!this._ds_get_first_available_tote_for_induction) {
      this._ds_get_first_available_tote_for_induction = this.injector.get(Totes_ds_get_first_available_tote_for_inductionService);
    }
    return this._ds_get_first_available_tote_for_induction;
  }
  private _ds_get_tote_containers: Totes_ds_get_tote_containersService;
  public get ds_get_tote_containers(): Totes_ds_get_tote_containersService {
    if(!this._ds_get_tote_containers) {
      this._ds_get_tote_containers = this.injector.get(Totes_ds_get_tote_containersService);
    }
    return this._ds_get_tote_containers;
  }
  private _ds_tote_container_statuses_dd: Totes_ds_tote_container_statuses_ddService;
  public get ds_tote_container_statuses_dd(): Totes_ds_tote_container_statuses_ddService {
    if(!this._ds_tote_container_statuses_dd) {
      this._ds_tote_container_statuses_dd = this.injector.get(Totes_ds_tote_container_statuses_ddService);
    }
    return this._ds_tote_container_statuses_dd;
  }
  private _ds_validate_scanned_tote: Totes_ds_validate_scanned_toteService;
  public get ds_validate_scanned_tote(): Totes_ds_validate_scanned_toteService {
    if(!this._ds_validate_scanned_tote) {
      this._ds_validate_scanned_tote = this.injector.get(Totes_ds_validate_scanned_toteService);
    }
    return this._ds_validate_scanned_tote;
  }
  private _ds_warehouses_dd: Totes_ds_warehouses_ddService;
  public get ds_warehouses_dd(): Totes_ds_warehouses_ddService {
    if(!this._ds_warehouses_dd) {
      this._ds_warehouses_dd = this.injector.get(Totes_ds_warehouses_ddService);
    }
    return this._ds_warehouses_dd;
  }
}

